import React from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "../ui/command";
import { SEARCH_INDEX } from "../../lib/navigation";

export default function SearchDialog({ open, setOpen }) {
  const navigate = useNavigate();

  React.useEffect(() => {
    const down = (e) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, [setOpen]);

  const go = (to) => {
    setOpen(false);
    navigate(to);
  };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput
        placeholder="Search topics — try 'Òrìṣà', 'Ifá', 'festivals'..."
        data-testid="search-input"
      />
      <CommandList>
        <CommandEmpty>No topics found.</CommandEmpty>
        <CommandGroup heading="Explore Yorùbá Culture">
          {SEARCH_INDEX.map((item) => (
            <CommandItem
              key={item.to + item.title}
              value={`${item.title} ${item.keywords || ""}`}
              onSelect={() => go(item.to)}
              className="cursor-pointer"
              data-testid={`search-result-${item.to}`}
            >
              <Search className="mr-2 h-4 w-4 text-gold" />
              {item.title}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
